import { cast, flow, toGenerator, types } from "mobx-state-tree";
import type { UserOrg } from "types/org";

interface CreateOrgInput {
  ownerId: string;
  name: string;
  slug?: string;
}

const UserOrgModel = types.model("UserOrg", {
  id: types.number,
  slug: types.string,
  name: types.string,
  isActive: types.boolean,
});

export const OrgStore = types
  .model("OrgStore", {
    orgs: types.array(UserOrgModel),
    selectedOrgId: types.maybe(types.number),
  })
  .actions((self) => ({
    setOrgs(orgs: UserOrg[]) {
      self.orgs = cast(orgs);
    },
    setSelectedOrg(id: number) {
      self.selectedOrgId = id;
    },
    createOrg: flow(function* (input: CreateOrgInput) {
      const { ownerId, name, slug } = input;
      const org = yield* toGenerator(createOrg(ownerId, name, slug));
      self.orgs.unshift(org);
      return org;
    }),
  }))
  .views((self) => ({
    get selectedOrg() {
      return self.orgs.find((org) => org.id === self.selectedOrgId);
    },
  }));

export const createOrgStore = () => {
  return OrgStore.create({});
};

async function createOrg(
  ownerId: string,
  name: string,
  slug?: string,
): Promise<UserOrg> {
  const response = await fetch(`/api/orgs`, {
    method: "POST",
    body: JSON.stringify({ ownerId, name, slug }),
  });
  if (!response.ok) {
    throw new Error("Failed to create org");
  }
  const data = (await response.json()) as UserOrg;
  return data;
}
